<div class="error">
  <div class="error-texto">
    <div>
      <p class="error-descripcion">{{errorDescription}}</p>
      <h3 class="error-codigo">ERROR<span>{{errorCode}}</span></h3>
      <neo-button class="btn-lg" [text]="'Volver al inicio '" [stroked]="true" [color]="'primary'" (accion)="redireccion()"></neo-button>
    </div>
  </div>
  <div class="error-imagen">
    <ng-container [ngSwitch]="errorCode">
      <ng-container *ngSwitchCase="'404'">
        <ng-template [ngTemplateOutlet]="svg404"></ng-template>
      </ng-container>
      <ng-container *ngSwitchCase="'500'">
        <ng-template [ngTemplateOutlet]="svg500"></ng-template>
      </ng-container>
      <ng-container *ngSwitchCaseDefault>
        <ng-template [ngTemplateOutlet]="svg404"></ng-template>
      </ng-container>
    </ng-container>
  </div>
  <neo-button class="btn-xs" [text]="'Volver al inicio '" [stroked]="true" [color]="'primary'" (accion)="redireccion()"></neo-button>
</div>

<ng-template #svg404>
  <neo-error404-svg></neo-error404-svg>
</ng-template>

<ng-template #svg500>
  <neo-error500-svg></neo-error500-svg>
</ng-template>
